// covered-by: frontends/carrie/src/ask-v2/rail/__tests__/AskV2RightRail.test.tsx
import { Button, Flex, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

type AskV2RailEarlierAnswerProps = {
  onShowLatest?: () => void;
};

/** Says the rail is on an earlier answer's citations, with a way back. */
export function AskV2RailEarlierAnswer({
  onShowLatest,
}: AskV2RailEarlierAnswerProps) {
  const { t } = useTranslation("ui");
  return (
    // why: without it the panel silently swaps to an older answer's sources as
    // the reader scrolls, and reads as the latest answer's.
    <Flex
      align="center"
      justify="between"
      gap="2"
      data-testid="ask-v2-rail-citations-earlier"
    >
      <Text size="1" className="text-puntt-neutral-gray-11">
        {t("askV2.rail.citationsFromEarlierAnswer")}
      </Text>
      {onShowLatest ? (
        <Button
          size="1"
          variant="ghost"
          data-testid="ask-v2-rail-citations-show-latest"
          onClick={onShowLatest}
        >
          {t("askV2.rail.showLatestCitations")}
        </Button>
      ) : null}
    </Flex>
  );
}
